import { EnabledFeatureFlags } from "components/providers/featureFlags/featureFlagContext";
import {
    featureFlags,
    FeatureFlagsWidened,
} from "components/providers/featureFlags/flags";
import CONSTANTS from "src/constants";

export function getInitialFeatureFlagState(
    searchParams: URLSearchParams,
): EnabledFeatureFlags {
    const entries = CONSTANTS.DEV
        ? Object.entries(featureFlags as FeatureFlagsWidened)
        : Array.from(searchParams.entries());

    return entries.reduce((acc, [key, _value]) => {
        if (!(key in featureFlags)) return acc;

        const value =
            typeof _value === "string"
                ? _value.toLowerCase().trim()
                : _value.defaultValue;
        const { type, options } = (featureFlags as FeatureFlagsWidened)[key];

        if (type === "enum") {
            if (
                value !== undefined &&
                !options.map((s) => s.toLowerCase()).includes(value as string)
            ) {
                console.warn(
                    `Feature flag ${key} has no variant ${value === "" ? "<empty string>" : value} (options: ${options.join(", ")})`,
                );
                return acc;
            }

            // @ts-expect-error can't associate key to array/boolean value precisely
            if (value) acc[key] = value;
            return acc;
        }

        // boolean flags
        if (
            value === true ||
            value === "" ||
            value === "true" ||
            value === "1"
        ) {
            // @ts-expect-error can't associate key to array/boolean value precisely
            acc[key] = true;
        } else if (value === false || value === "false" || value === "0") {
            // @ts-expect-error can't associate key to array/boolean value precisely
            acc[key] = false;
        }

        return acc;
    }, {} as EnabledFeatureFlags);
}
